import './ga4';
import './swiper';

window.addEventListener('load', function () {
    const dropdownToggle = document.querySelector('.dropdown-toggle');
    const dropdownMenu = document.querySelector('.dropdown ul');
    let mainNav = document.getElementById('main-nav');
    let toggleNavBtn = document.getElementById('burger-toggle');
    let closeNavBtn = document.getElementById('burger-close');
    const contactLink = document.getElementById('contact-link');
    
    if (dropdownToggle && dropdownMenu && mainNav && toggleNavBtn && closeNavBtn && contactLink) {
        // Ouverture / Fermeture du dropdown
        dropdownToggle.addEventListener('click', function(event) {
            event.preventDefault();
            dropdownMenu.classList.toggle('active');
        })
        
        // Fermeture du menu dropdown si on clique autre part
        document.addEventListener('click', function(event) {
            if (!dropdownMenu.contains(event.target) && !dropdownToggle.contains(event.target)) {
                dropdownMenu.classList.remove('active');
            }
        })

        function getScrollbarWidth() {
            const div = document.createElement('div');

            div.style.width = '100px';
            div.style.height = '100px';
            div.style.overflow = 'scroll';
            div.style.position = 'absolute';

            document.body.appendChild(div);

            const scrollbarWidth = div.offsetWidth - div.clientWidth;

            document.body.removeChild(div);

            return scrollbarWidth;
        }

        // Ouvrir le menu responsive
        function openNav() {
            const scrollbarWidth = getScrollbarWidth();
            document.body.style.paddingRight = `${scrollbarWidth}px`;
            mainNav.classList.add('active');
            document.body.classList.add('active');
        }
        
        // Fermer le menu responsive
        function closeNav() {
            mainNav.classList.remove('active');
            setTimeout(() => {
                document.body.style.paddingRight = '';
                document.body.classList.remove('active');
            }, 300);
        }
        
        // Gérer l'événement d'ouvrir/fermer le menu
        toggleNavBtn.addEventListener('click', openNav);
        closeNavBtn.addEventListener('click', closeNav);
        
        window.addEventListener('resize', function() {
            if (window.innerWidth >= 984 && document.body.classList.contains('active')) {
                closeNav();
            }
        })

        // Modifier le style du lien de contact
        function contactLinkStyleAdaptation() {
            if (window.innerWidth < 984) {
                contactLink.classList.remove('btn', 'btn-primary', 'mx-auto', 'rounded-5');
                contactLink.classList.add('navlink-primary-hover');
            }
            else {
                contactLink.classList.add('btn', 'btn-primary', 'mx-auto', 'py-2', 'rounded-5');
                contactLink.classList.remove('navlink-primary-hover');
            }
        }

        contactLinkStyleAdaptation();

        window.addEventListener('resize', contactLinkStyleAdaptation);
    }
    
    // Partie Tab dans la page produit
    const ingredientsTabLink = document.getElementById('ingredients-tab-link');
    const valeursNutritivesTabLink = document.getElementById('valeurs-nutritives-tab-link');
    const ingredientsTab = document.getElementById('ingredients-tab');
    const valeursNutritivesTab = document.getElementById('valeurs-nutritives-tab');
    
    if (ingredientsTabLink && valeursNutritivesTabLink && ingredientsTab && valeursNutritivesTab) {
        ingredientsTab.classList.remove('d-none');
        valeursNutritivesTab.classList.add('d-none');

        ingredientsTabLink.classList.add('border-bottom', 'border-black', 'border-5', 'fw-bold');
        valeursNutritivesTabLink.classList.remove('border-bottom', 'border-black', 'border-5', 'fw-bold');

        ingredientsTabLink.addEventListener('click', () => {
            ingredientsTab.classList.remove('d-none');
            valeursNutritivesTab.classList.add('d-none');
            ingredientsTabLink.classList.add('border-bottom', 'border-black', 'border-5', 'fw-bold');
            valeursNutritivesTabLink.classList.remove('border-bottom', 'border-black', 'border-5', 'fw-bold');
        });
        
        valeursNutritivesTabLink.addEventListener('click', () => {
            ingredientsTab.classList.add('d-none');
            valeursNutritivesTab.classList.remove('d-none');
            ingredientsTabLink.classList.remove('border-bottom', 'border-black', 'border-5', 'fw-bold');
            valeursNutritivesTabLink.classList.add('border-bottom', 'border-black', 'border-5', 'fw-bold');
        });
    }

    // Partie quantité d'un produit
    const minusButton = document.getElementById('quantity-minus');
    const plusButton = document.getElementById('quantity-plus');
    const quantityInput = document.querySelector('.quantity-input');

    if (quantityInput) {
        const minValue = parseInt(quantityInput.getAttribute('min')) || 1;
        quantityInput.value = minValue;
    }

    if (minusButton && plusButton && quantityInput) {
        minusButton.addEventListener('click', () => {
            const currentValue = parseInt(quantityInput.value);
            const minValue = parseInt(quantityInput.getAttribute('min')) || 1;
            if (currentValue > minValue) {
                quantityInput.value = currentValue - 1;
            }
        });
    
        plusButton.addEventListener('click', () => {
            const currentValue = parseInt(quantityInput.value);
            const maxValue = parseInt(quantityInput.getAttribute('max')) || Infinity;
            if (currentValue < maxValue) {
                quantityInput.value = currentValue + 1;
            }
        });
    }

    // Partie selection des attributs d'un produit
    const customOptions = document.querySelectorAll('.custom-options');

    customOptions.forEach(group => {
        const buttons = group.querySelectorAll('button');
        const attributeName = group.getAttribute('data-attribute');
        const select = document.querySelector(`select[name="attribute_${attributeName}"]`);
        const isParfumAttribute = attributeName == 'pa_parfum';

        // Fonction de syncronisation du style des boutons avec le choix du select auquel il est lié
        function syncButtons() {
            const selectedValue = select.value;
            let ingredientFound = false;
            let valeursNutritivesFound = false;

            buttons.forEach(button => {
                const buttonValue = button.getAttribute('data-value');
                if (buttonValue === selectedValue) {
                    button.classList.remove('border-secondary');
                    button.classList.add('border-primary', 'text-primary');
                }
                else {
                    button.classList.remove('border-primary', 'text-primary');
                    button.classList.add('border-secondary');
                }
            })

            if (isParfumAttribute) {
                const ingredientDivs = document.querySelectorAll('.ingredient-div');
                const valeursNutritivesDivs = document.querySelectorAll('.valeurs-nutritives-div');
                
                if (ingredientDivs) {
                    ingredientDivs.forEach(div => {
                        div.classList.remove('d-block');
                        div.classList.add('d-none');
        
                        if(div.id === selectedValue){
                            div.classList.add('d-block');
                            div.classList.remove('d-none');
                            ingredientFound = true;
                        }
                        else if(!['ingredient-message-select', 'ingredient-message-vide'].includes(div.id)){
                            div.classList.add('d-none');
                            div.classList.remove('d-block');
                        }
                    })
                }

                if (valeursNutritivesDivs) {
                    valeursNutritivesDivs.forEach(div => {
                        div.classList.remove('d-block');
                        div.classList.add('d-none');

                        if (div.id === `valeurs-nutritives-${selectedValue}`) {
                            div.classList.add('d-block');
                            div.classList.remove('d-none');
                            valeursNutritivesFound = true;
                        }
                        else if (!['valeurs-nutritives-message-select', 'valeurs-nutritives-message-vide'].includes(div.id)) {
                            div.classList.add('d-none');
                            div.classList.remove('d-block');
                        }
                    })
                }

                const selectMessage = document.getElementById('ingredient-message-select');
                const emptyMessage = document.getElementById('ingredient-message-vide');

                if (selectMessage && emptyMessage) {
                    if (selectedValue === '') {
                        selectMessage.classList.add('d-block');
                        selectMessage.classList.remove('d-none');
                        emptyMessage.classList.add('d-none');
                        emptyMessage.classList.remove('d-block');
                    }
                    else if (!ingredientFound) {
                        selectMessage.classList.add('d-none');
                        selectMessage.classList.remove('d-block');
                        emptyMessage.classList.add('d-block');
                        emptyMessage.classList.remove('d-none');
                    }
                    else {
                        selectMessage.classList.add('d-none');
                        selectMessage.classList.remove('d-block');
                        emptyMessage.classList.add('d-none');
                        emptyMessage.classList.remove('d-block');
                    }
                }

                const valeursNutritivesSelectMessage = document.getElementById('valeurs-nutritives-message-select');
                const valeursNutritivesEmptyMessage = document.getElementById('valeurs-nutritives-message-vide');

                if (valeursNutritivesSelectMessage && valeursNutritivesEmptyMessage) {
                    if (selectedValue === '') {
                        valeursNutritivesSelectMessage.classList.add('d-block');
                        valeursNutritivesSelectMessage.classList.remove('d-none');
                        valeursNutritivesEmptyMessage.classList.add('d-none');
                        valeursNutritivesEmptyMessage.classList.remove('d-block');
                    }
                    else if (!valeursNutritivesFound) {
                        valeursNutritivesSelectMessage.classList.add('d-none');
                        valeursNutritivesSelectMessage.classList.remove('d-block');
                        valeursNutritivesEmptyMessage.classList.add('d-block');
                        valeursNutritivesEmptyMessage.classList.remove('d-none');
                    } 
                    else {
                        valeursNutritivesSelectMessage.classList.add('d-none');
                        valeursNutritivesSelectMessage.classList.remove('d-block');
                        valeursNutritivesEmptyMessage.classList.add('d-none');
                        valeursNutritivesEmptyMessage.classList.remove('d-block');
                    }
                }
            }

        }


        // Syncro des boutons avec leur select respectif
        syncButtons();

        buttons.forEach(button => {
            button.addEventListener('click',() => {
                // Transformation de chaque bouton en bouton de base
                buttons.forEach(btn => {
                    btn.classList.remove('border-primary', 'text-primary');
                    btn.classList.add('border-secondary');
                });

                // Transformation du bouton actuel en bouton selectioné
                button.classList.remove('border-secondary');
                button.classList.add('border-primary', 'text-primary');
                
                // Mise à jour de la valeur du select caché
                select.value = button.getAttribute('data-value');
                select.dispatchEvent(new Event('change'));
                
                // Déclenchement de la vérification des variations pour WooCommerce
                jQuery('.variations_form').trigger('check_variations');
            });
        });

        // Syncro des bouton si le change
        select.addEventListener('change', syncButtons);
    });

    // Affichage d'une image en fonction de la variation
    const variationForm = document.querySelector('.variations_form');
    const productImage = document.querySelector('.product-main-image');

    if (variationForm && productImage) {
        jQuery(variationForm).on('found_variation', function (event, variation) {
            if (variation.image && variation.image.src) {
                if (productImage.src !== variation.image.src) {
                    productImage.src = variation.image.src;
                    productImage.srcset = variation.image.srcset || '';
                    productImage.alt = variation.image.alt || '';
                }
            }
            else{
                if (productImage.src !== productImage.getAttribute('data-default-src')) {
                    productImage.src = productImage.getAttribute('data-default-src');
                    productImage.srcset = '';
                    productImage.alt = '';
                }
            }
        });

        productImage.setAttribute('data-default-src', productImage.src);
    }

    // Création d'un cookie
    function setCookie(name, value) {
        const now = new Date();
        const midnight = new Date();

        midnight.setHours(24, 0, 0, 0);

        document.cookie = name + '=' + value + ';expires=' + midnight.toUTCString() + ';path=/';
    }

    // Obtenir un cookie
    function getCookie(name) {
        const cname = name + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1);
            if (c.indexOf(cname) === 0) return c.substring(cname.length, c.length);
        }

        return '';
    }

    // Fermer le popup
    function closePopup() {
        document.getElementById('custom-popup')?.classList.remove('show');
    }

    const popup = document.getElementById('custom-popup');

    if (popup && !getCookie('visited_home_popup')) {
        popup.classList.add('show');
        setCookie('visited_home_popup', 'yes');
    }

    const closeBtn = document.getElementById('popup-close-button');
    if (closeBtn) {
        closeBtn.addEventListener('click', closePopup);
    }
});